export default __webpack_public_path__ + "static/media/TIC logo.31240ee0.png";